import React, { useState } from 'react';
import { Button, Dropdown, Input, Space, Popconfirm } from 'antd';
import { BookOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';

interface SavedView {
  name: string;
  status: string | null;
  class: string | null;
  sort: string | null;
}

interface SavedViewsProps {
  currentStatus: string;
  currentClass: number | null;
  currentSort: string;
  onApply: (view: SavedView) => void;
}

const STORAGE_KEY = 'triage-saved-views';

function loadViews(): SavedView[] {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
  catch { return []; }
}

function saveViews(views: SavedView[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
}

const SavedViews: React.FC<SavedViewsProps> = ({ currentStatus, currentClass, currentSort, onApply }) => {
  const [views, setViews] = useState(loadViews);
  const [newName, setNewName] = useState('');
  const [open, setOpen] = useState(false);

  const handleSave = () => {
    if (!newName.trim()) return;
    const view: SavedView = {
      name: newName.trim(),
      status: currentStatus === 'open' ? null : currentStatus,
      class: currentClass ? String(currentClass) : null,
      sort: currentSort === 'oldest' ? null : currentSort,
    };
    const updated = [...views.filter((v) => v.name !== view.name), view];
    saveViews(updated);
    setViews(updated);
    setNewName('');
  };

  const handleDelete = (name: string) => {
    const updated = views.filter((v) => v.name !== name);
    saveViews(updated);
    setViews(updated);
  };

  const items = [
    ...views.map((v) => ({
      key: v.name,
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, minWidth: 180 }}>
          <span onClick={() => { onApply(v); setOpen(false); }} style={{ cursor: 'pointer', flex: 1 }}>{v.name}</span>
          <Popconfirm title="Delete this view?" onConfirm={() => handleDelete(v.name)} okText="Delete" okButtonProps={{ danger: true }}>
            <DeleteOutlined style={{ color: '#ff4d4f', fontSize: 11 }} />
          </Popconfirm>
        </div>
      ),
    })),
    { type: 'divider' as const, key: 'divider' },
    {
      key: 'save',
      label: (
        <Space size={4} onClick={(e) => e.stopPropagation()}>
          <Input
            size="small"
            placeholder="View name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onPressEnter={handleSave}
            onKeyDown={(e) => e.stopPropagation()}
            style={{ width: 130 }}
          />
          <Button size="small" type="text" icon={<PlusOutlined />} onClick={handleSave}>Save</Button>
        </Space>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }} open={open} onOpenChange={setOpen} trigger={['click']}>
      <Button size="small" type="text" icon={<BookOutlined />} />
    </Dropdown>
  );
};

export default SavedViews;
